/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_User_Role_DescriptionInputs */

const en_admin_settings_groups_user_role_description = /** @type {(inputs: Admin_Settings_Groups_User_Role_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default role for new users`)
};

const zh_admin_settings_groups_user_role_description = /** @type {(inputs: Admin_Settings_Groups_User_Role_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新用户默认角色`)
};

/**
* | output |
* | --- |
* | "Default role for new users" |
*
* @param {Admin_Settings_Groups_User_Role_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_user_role_description = /** @type {((inputs?: Admin_Settings_Groups_User_Role_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_User_Role_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_user_role_description(inputs)
	return zh_admin_settings_groups_user_role_description(inputs)
});
export { admin_settings_groups_user_role_description as "admin.settings.groups.user_role.description" }